export class VideoLicensesExhaustedError extends Error {
  constructor(message?: string) {
    super(message ?? 'No video licenses remain for this court system.')
    Object.setPrototypeOf(this, VideoLicensesExhaustedError.prototype)
  }
}
